const sessionConstants = {
  SESSION_EXPIRED: 'SESSION_EXPIRED',
  LOGIN_REQUIRED: 'LOGIN_REQUIRED',
};

export default sessionConstants;
